import React, {useMemo} from 'react';
import Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';
import moment from 'moment';
import {CONSTANT} from '../../../common/utils/constants';

interface TokenHoldingChartData {
    token: any,
    data?: any,
}

const TokenHoldingLineChart: React.FC<TokenHoldingChartData> = (props) => {
    const chartData = props.data ?? [];

    const options = useMemo(() => {
        const limitedData = chartData.slice(0, 15);

        return {
            chart: {
                plotBackgroundColor: null,
                plotBorderWidth: null,
                plotShadow: false,
                type: 'area',
                zoomType: '',
                height: 32,
                spacingLeft: 0,
                spacingRight: 0,
                marginBottom: 0,
                backgroundColor: 'transparent',
            },
            title: {text: ''},
            credits: {enabled: false},
            plotOptions: {
                series: {
                    color: `#${CONSTANT.CHART_COLOUR}`,
                    lineWidth: 2,
                    fillColor: `#${CONSTANT.CHART_COLOUR}66`,
                },
            },
            xAxis: {
                type: 'datetime',
                visible: false,
                lineWidth: 0,
                minorGridLineWidth: 0,
                lineColor: '#D3D3D3',
                minorTickLength: 0,
                tickLength: 0,
                offset: 0,
            },
            yAxis: {
                opposite: false,
                visible: false,
                lineWidth: 0,
                minorTickLength: 0,
                tickLength: 0,
            },
            legend: {
                enabled: false,
            },
            navigator: {
                enabled: false,
            },
            scrollbar: {
                enabled: false,
            },
            exporting: {
                enabled: false,
            },
            rangeSelector: {
                enabled: false,
            },
            series: [
                {
                    data: limitedData.map((e: any) => [
                        moment(e?.date, 'YYYY-MM-DD').valueOf(),
                        parseFloat(e?.holder_count)
                    ]),
                    marker: {
                        enabled: true,
                        radius: 2,
                    },
                },
            ],
            tooltip: {
                outside: true,
                enabled: true,
                useHTML: true,
                backgroundColor: "rgba(255, 255, 255, 0.8)",
                borderColor: `#${CONSTANT.CHART_COLOUR}`,
                borderWidth: 1,
                formatter: function (this: Highcharts.Point): string {
                    const x = this.x ?? 0;
                    const y = this.y ?? 0;
                    const nodeCount = y;
                    const date = moment(x).format('dddd, MMMM DD, YYYY');
                    return `
                            <table>
                                <tr>
                                    <td style="font-size: 10px;">${date}</td>
                                </tr>
                                <tr>
                                    <td style="font-size: 12px;">[<span style="color: #${CONSTANT.CHART_COLOUR}">Holding Count: </span><span style="font-weight: bold; color: black;">${nodeCount}</span>]</td>
                                </tr>
                            </table>`;
                },
            },
        };
    }, [chartData]);

    return (
        <div
            id="container-1"
            data-highcharts-chart="0"
            className="w-100"
            style={{height: "32px", width: "120px"}}
        >
            <div
                className="tradingview-widget-container"
                style={{height: "calc(100% - 12px)"}}
            >
                <HighchartsReact
                    highcharts={Highcharts}
                    options={options}
                />
            </div>
        </div>
    );
};

export default TokenHoldingLineChart;
